import { z } from 'zod'

import { TripId } from '@/types/common'
import { HotelId, HotelInfoZ, HotelZ } from '@/types/hotel'

import { getGGClient, RequestOverrides } from './GetGoingClient'

export async function getHotelInfo(hotelId: HotelId, overrides?: RequestOverrides) {
	return getGGClient()
		.request('GET', `hotels/${hotelId}`, {
			responseSchema: HotelInfoZ,
			...overrides,
		})
		.then((r) => r.data)
}

getHotelInfo.queryKey = (hotelId: HotelId) => ['hotelInfo', hotelId]

const HotelUpdateEmailRequestSchemaZ = HotelZ.pick({ email: true })

export async function updateHotelEmail(
	hotelId: HotelId,
	payload: z.infer<typeof HotelUpdateEmailRequestSchemaZ>,
	overrides?: RequestOverrides,
) {
	return getGGClient().request('PATCH', `hotels/${hotelId}`, {
		requestSchema: HotelUpdateEmailRequestSchemaZ,
		data: payload,
		...overrides,
	})
}

const PaymentConfirmationsResendRequestSchemaZ = z.object({ booking_segment_to_travelers: z.number().array() })

export async function resendHotelPaymentConfirmations(
	{ tripId, hotelId }: { tripId: TripId; hotelId: HotelId },
	payload: z.infer<typeof PaymentConfirmationsResendRequestSchemaZ>,
	overrides?: RequestOverrides,
) {
	return getGGClient().request('POST', `trips/${tripId}/hotels/${hotelId}/send_payment_communication`, {
		requestSchema: PaymentConfirmationsResendRequestSchemaZ,
		data: payload,
		...overrides,
	})
}
